export default "__VITE_ASSET__DygDvFwd__"